import { FC, PropsWithChildren } from 'react';
import { useContextSelector } from 'use-context-selector';
import classNames from 'classnames';
import { isUndefined } from 'lodash';

import { Box } from '../../Box';
import { BOX_COLOR_MAPPING } from '../Message.const';
import { MessageContext } from '../Message.context';
import { Typist } from '../../Typist';

import styles from '../Message.module.scss';

type MessageContentProps = PropsWithChildren<{}>;

export const MessageContent: FC<MessageContentProps> = ({ children }) => {
  const origin = useContextSelector(MessageContext, ({ origin }) => origin);

  const animate = useContextSelector(MessageContext, ({ animate }) => animate);

  const onAnimationCompleted = useContextSelector(
    MessageContext,
    ({ onAnimationCompleted }) => onAnimationCompleted
  );

  const isTyping = useContextSelector(
    MessageContext,
    ({ isTyping }) => isTyping
  );

  const content = (() => {
    if (!isUndefined(animate)) {
      return (
        <Typist speed={animate} onComplete={onAnimationCompleted}>
          {children as string}
        </Typist>
      );
    }
    return children;
  })();

  return (
    <Box
      color={BOX_COLOR_MAPPING[origin]}
      className={classNames(styles.box, styles[origin])}
    >
      <Box.Content className={styles.content}>
        {isTyping ? (
          <div style={{ paddingTop: 8, paddingInline: 12 }}>
            <div className={styles.dots} />
          </div>
        ) : (
          content
        )}
      </Box.Content>
    </Box>
  );
};
